// extracted by mini-css-extract-plugin
export default {"changePasswordForm":"ChangePassword_changePasswordForm__u1Rq-"};